import type { ReactNode } from "react";

export function StatusBanner({ kind, children }: { kind: "error" | "info" | "warning"; children: ReactNode }) {
  return <div className={`banner banner--${kind}`}>{children}</div>;
}
